import OwnerAccordion from "./ownerAccordion";
import RegisterVisual from "../Visual/registerVisual";
import Footer from "../footer";
import ApiAccordion from "./apiAccordion";
import ManufacturerParentAccordion from "./ManufacturerParentAccordion";

export default function AccountSettings() {

    return (<>
        <div className="company">
            <RegisterVisual title={"Account settings"}/>
            <div className="explorer">
                <OwnerAccordion />
            
                <ManufacturerParentAccordion/>

                <ApiAccordion />
            </div>

            <Footer/>
        </div>
    </>)
}